import type { AttachPointType } from '@app/api/collaboration';

type ProjectContext = { projectId: string };
type KeyContext = { keyId: string; keyName: string };
type TranslationContext = { translationId: string; language: string; keyName: string };
type ThreadContext = {
    parentCommentId: string;
    resolved: boolean;
    attachPointType: AttachPointType;
    attachPointId: string;
    attachPointName: string;
};

type ScrollPosition = { scrollPosition?: number };
type HasComments = { hasComments: boolean | undefined }; // Undefined === unknown (haven't loaded comments yet
type CanFilterResolvedComments = { showResolvedComments: boolean };

export enum CommentList {
    /* eslint-disable @typescript-eslint/naming-convention */
    Project = 'project',
    Key = 'key',
    Translation = 'translation',
    Thread = 'thread',
    /* eslint-enable @typescript-eslint/naming-convention */
}

export type ProjectCommentList = { type: CommentList.Project } & ProjectContext &
    CanFilterResolvedComments &
    HasComments &
    ScrollPosition;

export type KeyCommentList = { type: CommentList.Key } & ProjectContext & KeyContext & ScrollPosition;

export type TranslationCommentList = { type: CommentList.Translation } & ProjectContext &
    TranslationContext &
    ScrollPosition;

export type ThreadCommentList = { type: CommentList.Thread } & ProjectContext & ThreadContext & ScrollPosition;

export type CommentListType = ProjectCommentList | KeyCommentList | TranslationCommentList | ThreadCommentList;
